import { styled } from '@mui/material/styles';
import { Box } from 'shared/mui/Box';
import { Dialog } from 'shared/mui/Dialogs';

export const DialogStyled = styled(Dialog)({
  '.MuiCardContent-root': {
    padding: 0,
    paddingBottom: '0!important',
    ':&last-child': {
      paddingBottom: '0!important',
    },
  },
});

export const BoxStyled = styled(Box)({
  width: '640px',
});

export const FormBoxStyled = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  lineHeight: '24px',
});

export const ListStyled = styled('ul')({
  marginTop: 0,
  marginBottom: 0,
  paddingLeft: '20px',
});
